<template>
  <div class="posts-listing container page-container">
    <loader v-if="load"/>
    <div v-else class="row justify-content-center">
      <h1 id="title" class="col-12 text-center mb-5">Les actualités</h1>
      <div  v-for="post in posts" :key="post.id" class="col-12 col-md-6 col-lg-4">
        <post-card
          :card-image="post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url"
          :card-link="post.slug"
          :card-content="post.content.rendered"
          :card-title="post.title.rendered">
        </post-card>
      </div>
      <div class="col-12 load-more-container text-center mt-5" v-if="hasPages">
        <button @click="loadMore()" class="btn btn-primary">Charger plus d'actualités</button>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import PostCard from './PostCard'
import Loader from '@/components/Loader/Loader'
export default {
  components: { PostCard, Loader },
  data () {
    return {
      content: '',
      posts: [],
      load: true,
      nbPages: 0,
      nbPosts: 0,
      currentPage: 1
    }
  },
  computed: {
    // Retun true if posts listing have pagination (posts > 10)
    hasPages () {
      return this.currentPage < this.nbPages
    }
  },
  methods: {
    fetchPosts () {
      let url = api.posts + '&page=' + this.currentPage
      this.axios.get(url)
        .then(response => {
          this.posts = response.data
          this.load = false
          this.nbPosts = parseInt(response.headers['x-wp-total'])
          this.nbPages = parseInt(response.headers['x-wp-totalpages'])
          window.prerenderReady = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchMorePosts () {
      let url = api.posts + '&page=' + this.currentPage
      this.axios.get(url)
        .then(response => {
          let allPosts = this.posts.concat(response.data)
          this.posts = allPosts
          this.currentPage = this.currentPage + 1
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadMore () {
      this.currentPage = this.currentPage + 1
      this.fetchMorePosts()
    }
  },
  mounted () {
    // Fetch posts in data
    this.fetchPosts()
  }
}
</script>
<style lang="sass" scoped>
  @import 'PostsListing';
</style>



// WEBPACK FOOTER //
// src/components/Posts/PostsListing.vue